export const popoverPaperProps = {
  width: "400px",
  maxHeight: "500px",
  borderRadius: "12px",
  boxShadow: "0px 4px 20px #0000001A",
  mt: 1,
  overflow: "hidden",
};

export const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: 2,
  pb: 1,
};

export const notificationListStyle = {
  maxHeight: "350px",
  overflowY: "auto",
  p: 0,
};

export const notificationItemStyle = {
  py: 1.5,
  px: 2,
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  cursor: "pointer",
};

export const notificationTitleStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#333",
  textTransform: "capitalize",
};

export const notificationDescriptionStyle = {
  fontSize: "13px",
  color: "#555",
  lineHeight: 1.4,
  mt: 0.5,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

export const notificationDateStyle = {
  fontSize: "11px",
  color: "#888",
  mt: 0.5,
};

export const actionButtonsStyle = {
  display: "flex",
  gap: 0.5,
};

export const markAllReadButtonStyle = {
  color: "#666",
  "&:hover": {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  "&.Mui-disabled": {
    color: "#ccc",
  },
};

export const clearButtonStyle = {
  color: "#666",
  "&:hover": {
    backgroundColor: "#ffebee",
    color: "#d32f2f",
  },
};

export const noNotificationsStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  py: 6,
  px: 2,
};

export const loadingStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  py: 4,
  px: 2,
};

export const getChipProps = (type?: string) => {
  switch (type) {
    case "TASK":
      return { label: "Task", sx: { bgcolor: "#e3f2fd", color: "#1976d2" } };
    case "REFERRAL":
      return {
        label: "Referral",
        sx: { bgcolor: "#fff3e0", color: "#ed6c02" },
      };
    case "MESSAGE":
      return { label: "Message", sx: { bgcolor: "#e8f5e9", color: "#2e7d32" } };
    default:
      return { label: "General", sx: { bgcolor: "#f5f5f5", color: "#555" } };
  }
};
